<template>
    <div class="footer-area-wrapper" :class="FooterStyle">
        <div class="footer-area section-space--ptb_90">
            <div class="container">
                <div class="row footer-widget-wrapper">
                    <div class="col-lg-4 col-md-6 footer-widget">
                        <div class="footer-widget__logo mb-30">
                            <router-link to="/">
                                <img src="../assets/img/logo/logo-plum.png" class="img-fluid logo-dark" alt="">
                                <img src="../assets/img/logo/logo-white.png" class="img-fluid logo-light" alt="">
                            </router-link>
                        </div>
                        <ul class="footer-widget__list">
                            <li>Los Angeles, CA</li>
                            <li><a href="#" class="hover-style-link">hello@dennisrankin.com</a></li>
                            <li><a href="#" class="hover-style-link">(+1) (562) 548-0820</a></li>
                            <li><a href="#" class="hover-style-link hover-style-link--green">www.dennisrankin.com</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">Who we are</h6>
                        <ul class="footer-widget__list">
                            <li><a href="#about" class="hover-style-link">About</a></li>
                            <li><a href="#contact" class="hover-style-link">Contact </a></li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-6 footer-widget">
                        <h6 class="footer-widget__title mb-20">Quick links</h6>
                        <ul class="footer-widget__list">
                            <li><a href="/terms" class="hover-style-link">Terms</a></li>
                            <li><a href="/privacy-policy" class="hover-style-link">Privacy Policy</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-6 offset-lg-1 footer-widget">
                        <div class="twitter-feed-slider">
                            <div class="swiper-container twitter-feed-slider__container">
                                <div class="swiper-wrapper twitter-feed-slider__wrapper">
                                    <div class="swiper-slide twitter-feed-slider__single">
                                        <div class="tweet">
                                            <div class="tweet__text">
                                                "In the realm of ideas, everything depends on enthusiasm; in the real world, all rests on perseverance." <br /> -Johann Wolfgang von Goethe
                                            </div>
                                            <div class="tweet__info">
                                                <h6 class="tweet__heading">&nbsp;</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-copyright-area border-top section-space--ptb_30">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-md-6 text-center text-md-left">
                        <span class="copyright-text">© 2021 Dennis Rankin. All Rights Reserved.</span>
                    </div>
                    <div class="col-md-6 text-center text-md-right">
                        <ul class="list ht-social-networks solid-rounded-icon">
                            <li class="item">
                                <a href="https://www.facebook.com/dennis.rankin" target="_blank" class="social-link"> <i class="fab fa-facebook social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://twitter.com/thenextceo" target="_blank" class="social-link"> <i class="fab fa-twitter social-link-icon"></i> </a>
                            </li>
                            <li class="item">
                                <a href="https://instagram.com/thenextceo" target="_blank" class="social-link"> <i class="fab fa-instagram social-link-icon"></i> </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FooterMain',
        props: ["FooterStyle"]
    }
</script>
